import { createFileRoute } from "@tanstack/react-router";
import { CountryChannelLanding } from "@/components/country/shared/CountryChannelLanding";

export const Route = createFileRoute("/mexico/azteca")({
  head: () => ({
    meta: [
      { title: "VerseSport México + TV Azteca — Segunda pantalla del Mundial" },
      { name: "description", content: "Combina TV Azteca Deportes con VerseSport México: predicciones, Nation Wars y ranking del Tri en vivo." },
      { property: "og:title", content: "VerseSport México + TV Azteca" },
      { property: "og:description", content: "Predicciones y comunidad mientras ves TV Azteca." },
      { property: "og:url", content: "https://versesport.com/mexico/azteca" },
      { property: "og:type", content: "website" },
    ],
    links: [{ rel: "canonical", href: "https://versesport.com/mexico/azteca" }],
  }),
  component: () => (
    <CountryChannelLanding country="MX" channelId="azteca" intro="Acompaña a TV Azteca Deportes con predicciones, ranking del Tri y comunidad en tiempo real." />
  ),
});